"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _ExpandableAddon = _interopRequireDefault(require("../../ExpandableAddon")),
    _durations = require("../../../../constants/durations");

function Duration(a) {
  var b = a.duration,
      c = a.onChangeAddon,
      d = a.DURATIONS,
      e = a.disabled;
  return _react["default"].createElement(_ExpandableAddon["default"], {
    options: d,
    addonValue: b === _durations.DURATIONS.STANDARD ? void 0 : b,
    title: "Longform Edit",
    subtitle: "Select a final edit block length. Allow up to 72 hours.",
    onChangeAddon: c("DURATION"),
    disabled: e,
    suffixDoubleDagger: !0,
    type: "SINGLE"
  });
}

var _default = (0, _react.memo)(Duration);

exports["default"] = _default;